export const UNIT_CODE_OPTIONS = ['CL', 'ML', 'L', 'KG', 'G', 'STK'] as const;

export type UnitCode = typeof UNIT_CODE_OPTIONS[number];

const LIQUID_UNIT_CODES: UnitCode[] = ['CL', 'ML', 'L'];

export function isLiquidUnitCode(unitCode: string | null | undefined): boolean {
  return !!unitCode && LIQUID_UNIT_CODES.includes(unitCode as UnitCode);
}

/**
 * Client-side liter price preview.
 * L → price/unitContent; CL → price*100/unitContent; ML → price*1000/unitContent.
 * Returns null when not calculable (non-liquid unit, missing values, or unitContent <= 0).
 */
export function computeLiterPrice(
  price: number | null | undefined,
  unitCode: string | null | undefined,
  unitContent: number | null | undefined
): number | null {
  if (!isLiquidUnitCode(unitCode)) {
    return null;
  }

  const numericPrice = price != null ? Number(price) : NaN;
  const numericContent = unitContent != null ? Number(unitContent) : NaN;

  if (!Number.isFinite(numericPrice) || !Number.isFinite(numericContent) || numericContent <= 0) {
    return null;
  }

  switch (unitCode) {
    case 'L':
      return numericPrice / numericContent;
    case 'CL':
      return (numericPrice * 100) / numericContent;
    case 'ML':
      return (numericPrice * 1000) / numericContent;
    default:
      return null;
  }
}

export function formatLiterPriceDisplay(
  value: number | null | undefined,
  locale = 'da-DK'
): string {
  if (value == null || !Number.isFinite(value)) {
    return '—';
  }
  return new Intl.NumberFormat(locale, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(value);
}
